import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

import { Dvd } from 'interfaces';

import { AppLocale } from 'constant';

import { LanguageContext } from 'context/languageContext';

import Title from 'components/ui/Title';

import {
  Wrapper,
  DvdWrapper,
  SideWrapper,
  SideInfoBox,
  SectionWrapper,
  DvdPhoto
} from './DvdDetails.styles';

export interface AlbumDetailsProps {
  dvd: Dvd;
}

const DvdDetails = ({ dvd }: AlbumDetailsProps) => {
  const { locale } = useContext(LanguageContext);
  const intl = useIntl();

  return (
    <Wrapper>
      <Title size="big" color="secondary">
        {locale === AppLocale.EN ? dvd.englishName : dvd.name}
      </Title>
      <DvdWrapper flex>
        <SideWrapper>
          <DvdPhoto sorce={`/dvds/${dvd.id}.jpg`} vertical={dvd.isVerticalPhoto}></DvdPhoto>
          <SideInfoBox>
            <span>
              {intl.formatMessage({ id: 'albums.releaseDate' })}{' '}
              {intl.formatDate(new Date(dvd.releaseDate), {
                year: 'numeric', month: 'short', day: 'numeric'
              })}
            </span>
          </SideInfoBox>
        </SideWrapper>
        <SectionWrapper>
          [DESC]
        </SectionWrapper>
      </DvdWrapper>
    </Wrapper>
  );
};

export default DvdDetails;
